import { render, staticRenderFns } from "./ScratchWorkItem.vue?vue&type=template&id=75a79ac0&scoped=true&"
import script from "./ScratchWorkItem.vue?vue&type=script&lang=js&"
export * from "./ScratchWorkItem.vue?vue&type=script&lang=js&"
import style0 from "./ScratchWorkItem.vue?vue&type=style&index=0&id=75a79ac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a79ac0",
  null
  
)

export default component.exports